module.exports = __webpack_public_path__ + "dc09ab74bca28babcd3afaca67e6d998.png";